import { render } from "./entity_profile_overview.html?vue&type=template&id=1afe8908&external"
import script from "./entity_profile_overview.js?vue&type=script&lang=js&external"
export * from "./entity_profile_overview.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__